import moment from "moment";

/**
 * Clé de session pour un couple (schedule, date) — utilisée par le store
 * `confirmedDuplicates` pour mémoriser les doublons confirmés par l'utilisateur.
 *
 * Normalise la date en ISO UTC sans millisecondes pour garantir la cohérence
 * entre les différents points de déclenchement (ajout au panier, checkout, paiement).
 */
export default (scheduleId, date) =>
    `${scheduleId}|${moment(date).utc().set('millisecond', 0).toISOString()}`;
